import React, { PureComponent } from 'react';
import { message as AntMessage} from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';

const api = services.api;
/**
 * 可视化页面复制页面功能按钮
 */
export class PageCopyButton extends PureComponent<any, any> {
    copyPage = () => {
        const { entity, row:{id} } = this.props;
        api.get({}, { apiPath: `/page/clone/${id}`, apiRoot: ENV.API_ROOT }).then((data: any) => {
            if (data.result) {
                AntMessage.success('复制成功');
                entity.search({
                    ...entity.params,
                    ...entity.filters,
                });
            }
        })
        .catch(errorHandle)
    }
    render() {
        return (
            <a  className="table-action-column-item" onClick={this.copyPage}>
                复制
            </a>
        );
    }
}
